'use client';

import { useEffect } from 'react';

import { useAsPath } from './useAsPath';

/**
 * This hook listens to the route change and triggers the callback with the
 * current url.
 * @param onChange - A callback function that receives the current URL as an argument.
 * It is called whenever the route changes.
 */
export function useRouteChangeListener(onChange: (url: string) => void) {
  const { asPathUrl } = useAsPath();

  useEffect(() => {
    onChange(asPathUrl);
  }, [asPathUrl, onChange]);
}
